var ActiveMockService = /* @__PURE__ */ ((ActiveMockService2) => {
  ActiveMockService2["isActive"] = "is-active-mock-service-worker";
  ActiveMockService2["list"] = "list-mocks-active";
  return ActiveMockService2;
})(ActiveMockService || {});
export {
  ActiveMockService
};
//# sourceMappingURL=mock.js.map
